import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    shuffle as _shuffle,
} from 'lodash';

import '../../scss/GameScreen.scss'

import {
    setHiddenWord as setHiddenWordAction,
    setDisplayedList as setDisplayedListAction,
} from '../actions'
import WordGrid from '../components/WordGrid';
import WordLists from '../constants/WordLists';
import BackButtonImage from '../../icon/back.svg';
import RandomButtonImage from '../../icon/random.svg';
import ShuffleButtonImage from '../../icon/shuffle.svg';




const GameScreen = ({ currentWordListId, setHiddenWord, hiddenWord, displayedList, setDisplayedList }) => {

    

    function randomSelect() {
        var newRandomWord = '';

        //ensure same word is not selected twice in a row
        do {
            newRandomWord = displayedList[Math.floor(Math.random() * displayedList.length)];
        } while (newRandomWord === hiddenWord);

        setHiddenWord(newRandomWord);
    }

    function shuffleDisplayedList() {
        setDisplayedList(_shuffle(displayedList))
    }
    
    return(
    <div id="gameScreenContainer">
        <div id="topBar">
            <Link to="/wordgrid">
                <img
                    src={BackButtonImage}
                    alt="home button"
                    id='homeButton'
                />
            </Link>
            <span>
                <img
                    src={RandomButtonImage}
                    alt="random select button"
                    id='randomSelectButton'
                    onClick={() => randomSelect()}
                />
            </span>
            
            <span>
                <img
                    src={ShuffleButtonImage}
                    alt="shuffle list button"
                    id='shuffleListButton'
                    onClick={() => shuffleDisplayedList()}
                />
            </span>
            
            
        </div>
        
        <div id="gameContainer">
            <h1>{WordLists[currentWordListId].listName}</h1>
            <WordGrid />
        </div>
        
    </div>
    )
}

const mapStateToProps = state => ({
    currentWordListId: state.currentWordListIdState,
    hiddenWord: state.hiddenWordState,
    displayedList: state.displayedListState,
    
})

const mapDispatchToProps = dispatch => ({
    setHiddenWord: hiddenWord => dispatch(setHiddenWordAction(hiddenWord)),
    setDisplayedList: list  => dispatch(setDisplayedListAction(list)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GameScreen);